export default {
  name: 'marking--productionType',
};